import {
  aBigIntCountWithDelta,
  mockPipelineMetricsOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockPipelineMetricsOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insights: aBigIntCountWithDelta(),
          signals: aBigIntCountWithDelta(),
          records: aBigIntCountWithDelta(),
        },
      });
    }
  ),
];
